import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlatformService {

  private userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  isAndroid(): boolean {
    return /android/i.test(this.userAgent);
  }

  isIPhone(): boolean {
    return /iPhone/i.test(this.userAgent) && !('MSStream' in window);
  }

  isIPad(): boolean {
    return /iPad|iPod/i.test(this.userAgent) && !('MSStream' in window);
  }

  isMobile(): boolean {
    return this.isAndroid() || this.isIPhone() || this.isIPad();
  }

}
